import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

type SelectedProps = {
  selected?: boolean;
};

type ShowProps = {
  show?: boolean;
};

export const Container = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  flex-direction: column;
`;

export const ButtonToggle = styled.button`
  border: none;
  outline: none !important;
  border-radius: 6px;
  font-size: 0.75rem;
  background: transparent;
  padding: 0;

  flex: 1;
  display: flex;
  flex-direction: column;

  svg {
    color: ${({ theme }) => theme.colors.blue};
  }
`;

export const ButtonToggleContent = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 10px;
`;

export const ButtonAddUnit = styled(Link)`
  border: none;
  outline: none !important;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: ${({ theme }) => theme.colors.blueClean};
  color: ${({ theme }) => theme.colors.blue};
  padding: 10px;

  & svg {
    margin-right: 5px;
  }
`;

export const ContentUpper = styled.div<ShowProps>`
  display: ${({ show }) => (show ? 'flex' : 'none')};
  flex-direction: column;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: white;
  position: absolute;
  width: 100%;
  top: 37px;
  z-index: 9;
  max-height: 450px;
  overflow: auto;
`;

export const ContentSearch = styled.div`
  width: 100%;
  display: flex;
`;

export const ContentOthersUnits = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 10px;
  max-height: 450px;
  overflow: auto;
`;

export const HrCustom = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.gray};
  margin-bottom: 10px;
`;

export const ContentUnits = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 10px 0;
`;

export const UnitTitleAddress = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
  font-family: 'Mangueira bold';
  font-size: 12px;
  padding: 10px 10px 0;
`;

export const ContentUnitsWrap = styled.div`
  width: 100%;
  display: flex;
  padding: 6px 10px 0 0;
  align-items: center;
  justify-content: space-between;
`;

export const UnitSubtitleAddress = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
  font-size: 10px;
  padding: 0 10px 10px;
`;

export const UnitOldResident = styled.div<SelectedProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ selected }) => (selected ? '#e7eaff' : '#828282')};
  color: ${({ theme, selected }) => (selected ? theme?.colors?.blue : '#fff')};
  padding: 3px;
  width: 100%;
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
  font-size: 10px;
  font-weight: 700;
`;

type DeleteButtonProps = {
  isMobile?: boolean;
};

export const DeleteButton = styled.button<DeleteButtonProps>`
  display: ${({ isMobile }) => (isMobile ? 'flex' : 'none')};
  border: none;
  background-color: transparent;
`;

export const ContentUnit = styled.div<SelectedProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${({ theme, selected }) =>
    selected ? theme.colors.blue : '#efefef'};
  color: ${({ theme, selected }) => (selected ? '#fff' : theme.colors.gray)};
  border-radius: 3px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blue};
    color: #fff;

    ${UnitOldResident} {
      background-color: #e7eaff;
      color: ${({ theme }) => theme?.colors?.blue};
    }

    svg {
      fill: #fff;
    }

    ${ContentUnitsWrap} {
      ${DeleteButton} {
        display: flex;
      }
    }
  }
`;

export const TitleOthersUnits = styled.span`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 12px;
  font-family: 'Mangueira bold';
`;

export const TitleAddress = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
  font-family: 'Mangueira bold';
  font-size: 12px;
  color: ${({ theme }) => theme.colors.blue};
`;

export const SubtitleAddress = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 160px;
  font-size: 10px;
  color: ${({ theme }) => theme.colors.gray};
`;

export const AddressInButton = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
`;

export const OldResident = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #dadada;
  color: #7a7a7a;
  padding: 3px;
  width: calc(100% - 20px);
  border-radius: 8px;
  margin: 0 10px 5px;
`;

export const ModalConfirmStyled = styled(Modal)`
  & .modal-dialog {
    max-width: 550px;
    width: 100%;
  }

  & .modal-content {
    display: flex;
    flex-direction: column;
    padding: 25px 40px;
    width: 100%;

    @media (max-width: 768px) {
      padding: 25px;
    }
  }
`;
